
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AdministartionService } from 'src/app/service/administartion.service';
import { Constants } from 'src/app/constants';
import { Subject } from "rxjs";
@Component({
  selector: 'app-add-compliance-review',
  templateUrl: './add-compliance-review.component.html',
  styleUrls: ['./add-compliance-review.component.scss']
})
export class AddComplianceReviewComponent implements OnInit {
  playAudio: Subject<any> = new Subject();
  errorMessage: any = ''
  successMessage: any;
  errormsg: any
  successmsg: any
  heading: String = "header";
  showdata: any
  categorytype: any
  typedata: any

  constructor(public dialogRef: MatDialogRef<AddComplianceReviewComponent>, private constants: Constants,private ngxUiLoaderService: NgxUiLoaderService, @Inject(MAT_DIALOG_DATA) public dataStore: any, public adminService: AdministartionService) { }

  ngOnInit(): void {
    console.log(this.dataStore)
    this.heading = this.dataStore.header
    this.showdata = this.dataStore.showData
    this.categorytype = this.dataStore.showData?.issueId
    this.typedata = this.dataStore.typedata
    console.log("this.showdata", this.dataStore.showData)
  }
  showError(msg: string) {
    this.playAudio.next('trouble');
    this.errorMessage = msg;
    setTimeout(() => {
      this.successMessage = "";
      this.errorMessage = "";
    }, this.constants.notificationMessageTimeShort);
  }
  saveClick() {
    this.ngxUiLoaderService.start()
    let body = {
      siteID: this.dataStore?.siteID?.siteid,
      rowID: this.dataStore.showData.id,
      issueID: this.categorytype
    }
    console.log("body", body)

    this.adminService.updateNonComplianceIssues(body).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop()
        console.log("res", res)
        if (res?.status == 'SUCCESS') {
          this.dialogRef.close(
            {
              event: 'SaveEvent'
            }
          );
        }
        else if (res?.status == 'FAILURE') {
          this.errorMessage = 'Failed to Update';
          this.showError(this.errorMessage);
        }
      },
      error: (err: any) => {
        this.ngxUiLoaderService.stop()
        this.dialogRef.close(
          {
            event: 'failure'
          }
        );
      }
    })

  }


  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }



}
